import _extends from "@babel/runtime/helpers/esm/extends";
import { generateUtilityClasses, generateUtilityClass } from '@mui/base';
import { inputBaseClasses } from '../InputBase';
export function getInputUtilityClass(slot) {
  return generateUtilityClass('MuiInput', slot);
}

const inputClasses = _extends({}, inputBaseClasses, generateUtilityClasses('MuiInput', ['root', 'underline', 'input']));

export default inputClasses;